import { t } from "i18next";
import classnames from "classnames";
import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

import { QuestionsPage } from "./QuestionsPage";
import { QuestionModelEnum } from "../../enums";

type TProps = {
  subjectId: string;
  lessonId: string;
  header?: any;
};
export const QuestionsTabsPage: React.FC<TProps> = ({
  lessonId,
  header,
  subjectId,
}) => {
  //#region internal state
  const [tab, setTab] = useState("1");
  //#endregion

  //#region handler
  const toggleTab = (changingTab: any) => {
    if (changingTab !== tab) {
      setTab(changingTab);
    }
  };
  //#endregion

  return (
    <React.Fragment>
      <Container fluid>
        <Row className="mt-2 mb-4 align-items-center">
          <Col className="col-sm-auto">
            <div>
              <h4 className="mb-0">{header}</h4>
            </div>
          </Col>
          <Col className="col-sm">
            <div className="d-flex justify-content-sm-end gap-2">
              <Button color="success invisible">
                <i className="ri-add-fill me-1 align-bottom"></i>
                {t("addItem", { item: "question" })}
              </Button>
            </div>
          </Col>
        </Row>
        <Card>
          <div className="card-header align-items-center d-flex">
            <div className="flex-shrink-0 ms-2">
              <Nav
                tabs
                className="nav justify-content-end nav-tabs-custom rounded card-header-tabs border-bottom-0"
              >
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: tab === "1" })}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    {t("modelA")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: tab === "2" })}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    {t("modelB")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: tab === "3" })}
                    onClick={() => {
                      toggleTab("3");
                    }}
                  >
                    {t("modelC")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: tab === "4" })}
                    onClick={() => {
                      toggleTab("4");
                    }}
                  >
                    {t("modelD")}
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
          <CardBody>
            <TabContent activeTab={tab} className="text-muted">
              {tab === "1" && (
                <TabPane tabId="1">
                  <QuestionsPage
                    subjectId={subjectId}
                    lessonId={lessonId}
                    model={QuestionModelEnum.A}
                  />
                </TabPane>
              )}
              {tab === "2" && (
                <TabPane tabId="2">
                  <QuestionsPage
                    subjectId={subjectId}
                    lessonId={lessonId}
                    model={QuestionModelEnum.B}
                  />
                </TabPane>
              )}
              {tab === "3" && (
                <TabPane tabId="3">
                  <QuestionsPage
                    subjectId={subjectId}
                    lessonId={lessonId}
                    model={QuestionModelEnum.C}
                  />
                </TabPane>
              )}
              {tab === "4" && (
                <TabPane tabId="4">
                  <QuestionsPage
                    subjectId={subjectId}
                    lessonId={lessonId}
                    model={QuestionModelEnum.D}
                  />
                </TabPane>
              )}
            </TabContent>
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
};
